import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SessionExpiryService } from '../services/session-expiry.service';
import { StringEmpty } from '../utils/global-vars';
import { Store } from '@ngxs/store';
import { PostLogAction } from '../store/log/log.actions';

// temporary workaround until ngxs 4 published https://github.com/ngxs/store/issues/803
// export const silenceClientErrors = catchError(error => {
//   if (error.status < 500) {
//     error.message += ' (silence)';
//   }

//   return throwError(() => error);
// });

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  public async handleError(error: Error | HttpErrorResponse) {
    if (
      environment.debug &&
      (error as HttpErrorResponse).status !== 404 &&
      (error as HttpErrorResponse).status !== 304
    ) {
      console.error(error);
    }

    // temporary workaround until ngxs 4 published https://github.com/ngxs/store/issues/803
    // if (error.message?.includes('(silence)')) {
    //   return;
    // }

    const router = this.injector.get(Router);

    if (error instanceof HttpErrorResponse) {
      if (error.status === 403) {
        // Password expiry is handled by the Keycloak UPDATE_PASSWORD required
        // action at login, so 403 here only ever means permission denied.
        await router.navigate(['/error/permission-denied'], {
          state: { error: JSON.parse(JSON.stringify(error)) },
        });
      } else if (error.status === 401) {
        if (!router.url.includes('/login')) {
          // A 401 with a live SSO session is only a stale token: the service
          // refreshes it silently. Otherwise it starts the session-expired
          // exit (blocking dialog → logout → /error/session-expired).
          this.injector.get(SessionExpiryService).handleUnauthorized();
        }
      } else if (error.status !== 409 && error.status !== 406) {
        await this.redirectError(error);

        this.log(error);
      }
    } else {
      if (!environment.debug) {
        await this.redirectError(error);

        this.log(error);
      }
    }
  }

  private async redirectError(item) {
    const router = this.injector.get(Router);

    let error = item;

    if (!(error instanceof Error)) {
      error = JSON.parse(JSON.stringify(error));
    }

    await router.navigate(['/error/page-error'], { state: { error } });
  }

  private log(error) {
    let errorMessage = StringEmpty;
    let application = StringEmpty;
    if (error instanceof HttpErrorResponse) {
      // ? Is the logging of HttpErrorRespone actually done here??
      errorMessage = `HttpErrorResponse - Error Name: ${error.message} </br>Error Message: ${error.error}`;
    } else {
      application = 'platform'; // Error from frontend will be considered as platform
      errorMessage = `Frontend Error - Error Name: ${error.message} </br>Error Message: ${error.error}`;
    }

    const store = this.injector.get(Store);
    store.dispatch(
      new PostLogAction({
        operation: StringEmpty,
        application: application,
        study: null,
        success: false,
        error: errorMessage,
        entityValue: 'Global Error Handler',
      }),
    );
  }
}
